import styled from "styled-components";
import { Colors } from "../../../../values/colors";

export const SeparationColumn = styled.div`
  display: grid;
  grid-template-columns: 310fr 355fr;
  gap: 30px;
  width: 100%;
  box-sizing: border-box;

  > div {
    min-width: 0;
    overflow: hidden;
  }
`;

export const SessionMarkers = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 4px 6px;
  font-size: 15px;
  font-weight: 700;
  background: ${Colors.ultraLightGray3};
  color: ${Colors.black};
  border-radius: 6px;
`;

export const SectionDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${ Colors.secondaryPurple };
  display: inline-block;
`;

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: ${Colors.blueGray};
`;

export const TitleIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${Colors.primaryPurple};
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 12px;
  color: ${Colors.blueMist};
  margin-bottom: 6px;
`;

export const TextInput = styled.input`
  width: 100%;
  padding: 9px 12px;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 6px;
  font-size: 14px;
  color: ${Colors.blueGray};
  outline: none;
  box-sizing: border-box;
  background: #fff;

  &:focus {
    border-color: ${Colors.primary};
  }

  &::placeholder {
    color: ${Colors.lightGray};
  }

  &:disabled {
    background: ${Colors.ultraLightGray2};
    cursor: not-allowed;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 9px 12px;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 6px;
  font-size: 14px;
  color: ${Colors.blueGray};
  outline: none;
  box-sizing: border-box;
  background: #fff;
  resize: vertical;
  min-height: 72px;
  font-family: inherit;

  &:focus {
    border-color: ${Colors.primary};
  }

  &::placeholder {
    color: ${Colors.lightGray};
  }
`;

export const SelectInput = styled.select`
  width: 100%;
  padding: 9px 12px;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 6px;
  font-size: 14px;
  color: ${Colors.blueGray};
  outline: none;
  background: #fff;
  cursor: pointer;

  &:focus {
    border-color: ${Colors.primary};
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
`;

export const TwoCol = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

export const CancelBtn = styled.button`
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 600;
  color: ${Colors.blueGray};
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 99px;

  &:hover {
    background: ${Colors.ultraLightGray2};
  }
`;

export const ConfirmBtn = styled.button`
  padding: 9px 28px;
  border-radius: 8px;
  border: none;
  background: ${({ bg, disabled }) => (disabled ? Colors.ultraLightGray : bg || Colors.primary)};
  color: ${({ disabled }) => (disabled ? Colors.lightGray : "#fff")};
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.88;
  }
`;

export const ConfirmBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 0 16px;
`;

export const ConfirmIcon = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: ${({ color }) => color || Colors.primaryPurple};
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const ConfirmText = styled.p`
  font-size: 14px;
  color: ${Colors.blueMist};
  margin: 0;
  line-height: 1.5;
`;

export const PlanNameQuote = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: ${Colors.blueGray};
  margin: 0;
`;

export const DeclarationBox = styled.div`
  background: rgba(45, 206, 159, 0.08);
  border: 1px solid rgba(45, 206, 159, 0.35);
  border-radius: 8px;
  padding: 14px 16px;
`;

export const DeclarationHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: ${Colors.secondaryGreen};
  margin-bottom: 8px;
`;

export const DeclarationText = styled.p`
  font-size: 13px;
  color: ${Colors.blueGray};
  margin: 0;
  line-height: 1.55;
`;

export const AuditNote = styled.p`
  font-size: 12px;
  color: ${Colors.blueMist};
  margin: 0;
  line-height: 1.5;
`;